import React, { Fragment, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SimpleTextModal from "../modals/SimpleTextModal";

const CookiesPolicy = (props) => {
    const { t } = useTranslation();
    const [showCookiePoliticsModal, setShowCookiePoliticsModal] = useState(false);

    return (
        <Fragment>
            <Button variant="link" onClick={() => setShowCookiePoliticsModal(true)}>
                {t("cookiePolitics")}
            </Button>
            {showCookiePoliticsModal && <SimpleTextModal title={t("cookiePolitics")} txt={t("cookiePoliticsTxt")} onClose={() => setShowCookiePoliticsModal(false)} show={true} />}
        </Fragment>
    );
};

export default CookiesPolicy;
